<ion-header [translucent]="true" collapse="fade">
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (canGoBack) {
        <ion-back-button text="" defaultHref="news"/>
      } @else {
        <ion-menu-button/>
      }
    </ion-buttons>

    <div class="flex items-center">
      <ion-title class="px-4 line-clamp-1 min-w-0 inline-flex self-center sm:hidden">
        @if (isMobile) {
          {{ title }}
        } @else {
          Pfaffenhofen-App
        }
      </ion-title>
      <div class="hidden sm:block flex-1 space-x-4 absolute left-[50%] translate-x-[-50%] whitespace-nowrap">
        <ion-nav-link class="cursor-pointer" routerLinkActive="font-bold" [routerLink]="'/news'">
          News
        </ion-nav-link>
        <ion-nav-link class="cursor-pointer" routerLinkActive="font-bold" [routerLink]="'/events'">
          Events
        </ion-nav-link>
        <ion-nav-link class="cursor-pointer" routerLinkActive="font-bold" [routerLink]="'/places/map'">
          Orte
        </ion-nav-link>
        @if (settingsService.settings().features.articles) {
          <ion-nav-link class="cursor-pointer" routerLinkActive="font-bold" [routerLink]="'/articles'">
            Nachbarschafts-Netzwerk
          </ion-nav-link>
        }
      </div>
    </div>

    <ion-buttons slot="end">
      @if (!hideSearchButton) {
        <ion-button id="search-button" [routerLink]="'/search'" size="small"
                    class="bg-gray-500 rounded-full max-w-10 max-h-10">
          <ion-icon name="search-outline" slot="icon-only" size="large"/>
        </ion-button>
      }

      <ion-button [routerLink]="'/user/login'" size="small"
                  class="hidden sm:inline-flex bg-gray-500 rounded-full max-w-10 max-h-10 !ml-2">
        @if (user()) {
          <span class="text-sm font-medium text-white pt-3 pb-3 leading-3">{{ user()?.getInitials() }}</span>
        } @else {
          <ion-icon name="person-outline" slot="icon-only"/>
        }
      </ion-button>
    </ion-buttons>

    <!--    <div slot="end" class="pr-4 flex items-center justify-end">-->
    <!--      <div class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-500 cursor-pointer"-->
    <!--           [routerLink]="'/search'">-->
    <!--        <ng-icon name="heroMagnifyingGlass" class="text-white" size="1.25rem"/>-->
    <!--      </div>-->

    <!--      <div [routerLink]="'/user/login'"-->
    <!--           class="h-8 w-8 ml-3 items-center justify-center rounded-full bg-gray-500 cursor-pointer hidden sm:inline-flex">-->
    <!--        @if (user()) {-->
    <!--          <span class="text-sm font-medium leading-none text-white">{{ user()?.getInitials() }}</span>-->
    <!--        } @else {-->
    <!--          <ng-icon name="heroUser" class="text-white" size="1.25rem"/>-->
    <!--        }-->
    <!--      </div>-->
    <!--    </div>-->

    @if (showProgressBar()) {
      <ion-progress-bar class="mb-0 pb-0" type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>
